import {HttpClient} from '~/library/network-facade';
import {MetricsType, sendMetrics} from '~/shared/logging';

// TODO: clean this up a little, for know I just moved it to separate module
export default {
    initialize() {
        const listener = () => {
            const loadingTime = performance.now().toFixed(2);
            document.dispatchEvent(new SendStatsEvent(loadingTime));
        };
        window.addEventListener('load', listener, false);
    },
    onAppMounted(http: HttpClient) {
        const listener = ((e: SendStatsEvent) => {
            sendMetrics(http, {
                name: 'react_app_index_load_ms',
                type: MetricsType.Gauge,
                value: e.detail.loading_time,
            });
        }) as (e: Event) => void;

        document.addEventListener(SendStatsEvent.type, listener, false);
    },
};

class SendStatsEvent extends CustomEvent<{loading_time: string}> {
    static type = 'send_stat';

    constructor(loadingTime: string) {
        super('send_stat', {detail: {loading_time: loadingTime}});
    }
}
